import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import Table from "../../core/common/dataTable/index";
import api from "../../api"; // your custom API method
import useDynamicPageSize from "../../useDynamicPageSize";
import { useLocation, useNavigate } from "react-router-dom";
import { useHeaderFilters } from "../../context/HeaderFilterContext";
import StatCardGrid from "./statCardGrid";
import CommonSelect from "../../core/common/commonSelect";
import { toast, ToastContainer } from "react-toastify";
import Footer from "../../Footer";
import { DatePicker } from "antd";
import dayjs, { Dayjs } from "dayjs";
import moment from "moment";
import { FaRecordVinyl } from "react-icons/fa";
import { Link } from "react-router-dom";

interface LocationState {
  monthYear?: string;
  previousUrl?: string;
}
type ModalMode = "add" | "edit" | "info";

type PayheadValues = { [key: number]: string | number };

type Option = { label: string; value: any };

type AttendanceErrorResponse = {
  status: "error";
  message: string;
  errors?: Record<string, boolean>;
};

type AttendanceSuccessResponse = {
  status: string;
  payhead_values: Record<string, number>;
  netsalary: number;
  gross: number;
  emp: string;
  doj: string;
  lop: number;
  employeeid: string;
};

type AttendanceResponse =
  | AttendanceSuccessResponse
  | AttendanceErrorResponse;

interface DefaultEmployees {
  id: number;
  employee_id: string;
}
interface Payhead {
  id: number;
  name: string;
  description: string;
}

interface User {
  id: number;
  name: string;
  employee_id: string;
}

interface SalaryData {
  employee_id: number;
  month: string;
  year: string;
  LOP: number;
  incentive: number;
  gross: number;
  netSalary: number;
  payheadValues: Record<string, number>;
  editId?: number;
}

interface SalaryDetail {
  lop: string;
  id: number;
  user_id: number;
  Gross: number;
  Incentives: number;
  SD: number;
  TDS: number;
  PT: number;
  pfC: number;
  ESIC: number;
  Net_salary: number;
  flag: number;
   // add these:
  name?: string;
  employee_id?: string;
  user: {
    date_of_joining: string | undefined;
    employee_id: string;
    id: number;
    user_id:number;
    name: string;
    designation?: {
      title: string;
    };
  };
  image_url?: string;
}

interface ApiResponse {
  users: User[];
  defaultEmployee: DefaultEmployees | null;
  payheads: Payhead[];
  actualsalarydetails: {
    data: SalaryDetail[];
    current_page: number;
    last_page: number;
    total: number;
  };
  month: string;
  year: string;
  totalGross: string;
  totalNet: string;
  totalSD: string;
  totalTDS: string;
  totalPF: string;
  totalESIC: string;
}

interface RecalculationResponse {
  gross: string;
  netsalary: string;
  payhead: PayheadValues;
}
interface SalaryDisbursementModalProps {
  show: boolean;
  onClose: () => void;
  selectedEmployees: string[];
  currentPage: number;
  pageSize: number;
  fetchSalaryDetails: (
    month: string,
    year: string,
    page: number,
    size: number
  ) => Promise<void>;
  fiscalMonth: string;
  year: string;
}

const MonthlySalary: React.FC = () => {
  const location = useLocation();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 767);
 const { state } = location;
 const openedViaButtonRef = useRef(false);


const monthYear = state && "monthYear" in state ? state.monthYear : sessionStorage.getItem("monthYear") || "";
const previousUrl = state && "previousUrl" in state ? state.previousUrl : "/payroll";
const [attendanceError, setAttendanceError] = useState<string | null>(null);
const [attendanceErrorDetails, setAttendanceErrorDetails] = useState<
  Record<string, boolean> | null
>(null);
const [salaryBlocked, setSalaryBlocked] = useState(false);



  const breadcrumbs = [
    // always show â€œPayrollâ€
    { title: "Payroll", path: previousUrl || "/payroll" },

    // only show the month crumb if monthYear is set
    ...(monthYear
      ? [
          {
            title: monthYear,
            // clicking takes you back to payroll
            path: previousUrl || "/payroll",
          },
        ]
      : []),
  ];
  const pageSize = useDynamicPageSize();
  const navigate = useNavigate();
  const { setFilters } = useHeaderFilters();
  const [showSendMailModal, setShowSendMailModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const [defaultEmployeeId, setDefaultEmployeeId] = useState<
    string | number | null
  >(null);

  const [users, setUsers] = useState<User[]>([]);
  const [modalMode, setModalMode] = useState<ModalMode>("add");
  const [salaryDetails, setSalaryDetails] = useState<SalaryDetail[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedEmployees, setSelectedEmployees] = useState<number[]>([]);
  const [totalGross, setTotalGross] = useState("0");
  const [totalSD, setTotalSD] = useState("0");
  const [totalTDS, setTotalTDS] = useState("0");
  const [totalNet, setTotalNet] = useState("0");
  const [totalPF, setTotalPF] = useState("0");
  const [totalESIC, setTotalESIC] = useState("0");
  const [loading, setLoading] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [disburseDate, setDisburseDate] = useState<Dayjs | null>(null);
  const [validationMessage, setValidationMessage] = useState("");
  const [isSending, setIsSending] = useState(false);

  // New state variables to support edit modal
  const [showModal, setShowModal] = useState<boolean>(false);
  const [editing, setEditing] = useState(false);
  const [editId, setEditId] = useState<number | string>("");
  const [employeeId, setEmployeeId] = useState<number | string>("");
  const [employeeCode, setEmployeeCode] = useState<string>(""); // This is like "E00119"
  const [employee_id, setEmployee_id] = useState<number | string>(0);
  const [gross, setGross] = useState<number | string>("");
  const isInitialFetch = useRef(true);
  const [incentive, setIncentive] = useState<number | string>("");
  const [lop, setLop] = useState<number | string>("");
  const [flag, setFlag] = useState<number | string>("");

  const [errorMessage, setErrorMessage] = useState("");
  const [currentEmployeeIndex, setCurrentEmployeeIndex] = useState(0);

  const [tableHeight, setTableHeight] = useState<number>(0);

 useLayoutEffect(() => {
  const calcHeight = () => {
    const w = window.innerWidth;
    const h = window.innerHeight;

    const isTablet = w > 575 && w <= 991;
    const isMobile = w <= 575 || w <= 991;

    let topBlocks = 0;
    if (w <= 360)        topBlocks = 245;   
    else if (w <= 410)   topBlocks = 245;   
    else if (w <= 575)   topBlocks = 245;  
    else if (w <= 767)   topBlocks = 160;   
    else if (w <= 991)   topBlocks = 160;   
    else                 topBlocks = 140;   

    const pagination = document.getElementById("pagination-bar");
    const footer     = document.getElementById("footer");
    const paginationH = pagination?.offsetHeight ?? 25;
    const footerH     = footer?.offsetHeight ?? 50;

    const reserved = topBlocks + paginationH + footerH;
    const newHeight = Math.max(220, h - reserved);

    setTableHeight(newHeight);
  };

  calcHeight();                      // initial
  window.addEventListener("resize", calcHeight);
  return () => window.removeEventListener("resize", calcHeight);
}, []);


  const [formState, setFormState] = useState({
    employee_id: 0,
    LOP: 0,
    incentive: 0,
    gross: 0,
    netSalary: 0,
    payheadValues: {},
    editing: false,
    editId: undefined,
  });

  const [empName, setEmpName] = useState<string>("");
  const [doj, setDoj] = useState<string>("");
  const [payheads, setPayheads] = useState<Payhead[]>([]);
  const [payheadValues, setPayheadValues] = useState<PayheadValues>({});
  const [netSalary, setNetSalary] = useState<number | string>("");
  const [LOP, setLOP] = useState<string>("");
  const [incentiveAdded, setIncentiveAdded] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const isSaveDisabled =
    isLoading ||
    isSending ||
   salaryBlocked;
  const queryParams = new URLSearchParams(location.search);
const fiscalMonth =
  queryParams.get("month") ||
  sessionStorage.getItem("month") ||
  String(new Date().getMonth() + 1); // fallback: current month number

const year =
  queryParams.get("year") ||
  sessionStorage.getItem("year") ||
  String(new Date().getFullYear()); // fallback: current year

  const formatCurrency = (value: number | string) =>
    new Intl.NumberFormat("en-IN", {
      // style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
    }).format(Number(value));

  const fetchSalaryData = async () => {
    try {
      setLoading(true);
      const id = JSON.parse(localStorage.getItem("user") || "{}")?.id;

      const res = await api<ApiResponse>("/monthly-salary", {
        method: "POST",
        body: {
          id,
         month: fiscalMonth || sessionStorage.getItem("month"),
  year: year || sessionStorage.getItem("year"),
          currentPage,
          pageSize,
        },
      });
const enriched = res.actualsalarydetails.data.map(d => ({
  ...d,
  user: d.user ?? {
    id: d.user_id,
    name: d.name,
    employee_id: d.employee_id,
    designation: { title: "" }
  }
}));
setSalaryDetails(enriched);
      // setSalaryDetails(res.actualsalarydetails.data || []);
      setTotalItems(res.actualsalarydetails.total || 0);
      setTotalGross(res.totalGross);
      setTotalNet(res.totalNet);
      setTotalSD(res.totalSD);
      setTotalTDS(res.totalTDS);
      setTotalPF(res.totalPF);
      setTotalESIC(res.totalESIC);

      // SAFELY extract default employee
      if (res.defaultEmployee?.id) {
        setDefaultEmployeeId(res.defaultEmployee?.id);
      } else {
        setDefaultEmployeeId(null);
      }

      setUsers(res.users || []);
      setPayheads(res.payheads || []);
    } catch (err) {
      console.error("Error loading salary data", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
     if (isInitialFetch.current) {
      isInitialFetch.current = false;
      return;
    }
    fetchSalaryData();
  }, [currentPage, pageSize]);

  const handleSetDefaultEmployee = (res: ApiResponse) => {
    if (res.defaultEmployee?.id) {
      setDefaultEmployeeId(res.defaultEmployee.id);
    } else {
      setDefaultEmployeeId(null);
    }
  };

  const salaryDisbursement = async () => {
    if (!disburseDate) {
      setValidationMessage(
        "Please select a date before disbursing the salary."
      );
      setTimeout(() => setValidationMessage(""), 3000);
      return;
    }

    try {
      setIsSending(true);
      const formattedDate = disburseDate.format("YYYY-MM-DD");

      await api("/salary-disbursement", {
        method: "POST",
        body: {
          selectedEmployees,
          date: formattedDate,
          month: fiscalMonth || sessionStorage.getItem("month"),
  year: year || sessionStorage.getItem("year"),
        },
      });

      await fetchSalaryData();
      setShowModal2(false);
    } catch (error: any) {
      console.error("Disbursement error:", error.message || error);
    } finally {
      setIsSending(false);
    }
  };
  const handleInfoClick = async (detail: SalaryDetail) => {
    try {
      const response = await api<{
        existingsalary: {
          id: number;
          user_id: number;
          month: string;
          year: string;
          lop: number;
          Gross: number;
          Net_salary: number;
          Incentives: number;
          flag: number;
          date_of_joining?: string;
        };
        payhead: Record<string, number>;
      }>("/edit-actual-salary", {
        method: "POST",
        body: { month: fiscalMonth || sessionStorage.getItem("month"),
  year: year || sessionStorage.getItem("year"), id: detail.user.id },
      });

      const { existingsalary, payhead } = response;

      const formatDate = (dateStr?: string) => {
        if (!dateStr) return "";
        return dayjs(dateStr, "DD-MM-YYYY").format("DD-MMM-YYYY");
      };
      // format date, normalize payheadâ€¦
      setModalMode("info");
      setShowModal(true);
      setEditing(true);
      setFlag(existingsalary.flag);
      setEditId(existingsalary.user_id);
      setEmployee_id(existingsalary.user_id);
      setEmployeeId(detail.user.employee_id);
      setLOP(String(existingsalary.lop));
      // setLop(existingsalary.lop.toString());
      setEmpName(detail.user.name);
      setDoj(formatDate(detail.user?.date_of_joining));
      setGross(existingsalary.Gross.toString());
      setNetSalary(existingsalary.Net_salary.toString());
      setIncentive(existingsalary.Incentives.toString());
      // normalize payhead valuesâ€¦
      const normalized: PayheadValues = {};
      Object.entries(payhead).forEach(([k, v]) => (normalized[+k] = v));
      setPayheadValues(normalized);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load employee info.");
    }
  };

  const handleEditClick = async (detail: SalaryDetail) => {
    try {
      // 1) Fetch existing salary and payhead breakdown
      const response = await api<{
        existingsalary: {
          id: number;
          user_id: number;
          month: string;
          year: string;
          lop: number;
          Gross: number;
          Net_salary: number;
          Incentives: number;
          flag: number;
          date_of_joining?: string;
        };
        payhead: Record<string, number>;
      }>("/edit-actual-salary", {
        method: "POST",
        body: {
         month: fiscalMonth || sessionStorage.getItem("month"),
  year: year || sessionStorage.getItem("year"),
          id: detail.user?.id,
        },
      });

      const { existingsalary, payhead } = response;

      // Helper to format "DD-MM-YYYY" â†’ "DD-MMM-YYYY"
      const formatDate = (dateStr?: string) => {
        if (!dateStr) return "";
        return dayjs(dateStr, "DD-MM-YYYY").format("DD-MMM-YYYY");
      };

      // 2) Enter edit mode and show the modal
      setModalMode("edit");
      setShowModal(true);

      // 3) Populate state
      setEditing(true);
      setFlag(existingsalary.flag);
      setEditId(existingsalary.id);
      setEmployee_id(existingsalary.user_id); // internal user ID
      setEmployeeId(detail.user?.employee_id || ""); // displayed employee code
      // setLop(existingsalary.lop.toString());             // LOP remains editable
      setLOP(String(existingsalary.lop));

      setEmpName(detail.user?.name || "N/A");
      setDoj(formatDate(detail.user?.date_of_joining));
      setGross(existingsalary.Gross.toString());
      setNetSalary(existingsalary.Net_salary.toString());
      setIncentive(existingsalary.Incentives.toString());

      // 4) Normalize and set payhead values (all read-only except LOP)
      const normalized: PayheadValues = {};
      Object.entries(payhead).forEach(([key, value]) => {
        normalized[Number(key)] = value;
      });
      setPayheadValues(normalized);
    } catch (error: any) {
      console.error("Edit salary load error:", error.message || error);
      toast.error("Failed to load salary for editing.");
    }
  };
  console.log("payhead:", payheads);
  useEffect(() => {
    if (showModal2) {
      setDisburseDate(null); // Clear date picker when modal opens
      setValidationMessage(""); // Optionally clear validation too
    }
  }, [showModal2]);

  // const handleIncentiveBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    // const { value } = event.target;
    // const parsedIncentive = parseFloat(value);

    // if (!isNaN(parsedIncentive)) {
    //   // if (incentiveAdded) {
    //   //   console.log("Incentive has already been added.");
    //   //   return;
    //   // }

    //   const previousNet = parseFloat(netSalary.toString()) || 0;
    //   const newNet = previousNet + parsedIncentive;

    //   console.log("previousNetSalary", previousNet);
    //   console.log("incentive", parsedIncentive);
    //   console.log("newNetSalary", newNet);

    //   setIncentive(value);
    //   setNetSalary(newNet);
    //   setIncentiveAdded(true);
    // } else {
    //   console.log("Invalid incentive value");
    // }
  // };

  // Input Change Handler
const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value } = event.target;

  if (name === "employee_id") {
    setEmployeeId(value);
    fetchEmployeeSalaryDetails(value);
  } else if (name === "LOP") {
    setLOP(value);
    const payhead6 = Number(payheadValues[6]) || 0;
    const payhead11 = Number(payheadValues[11]) || 0;
    const payhead13 = Number(payheadValues[13]) || 0;
    const payhead14 = Number(payheadValues[14]) || 0;
    const payhead15 = Number(payheadValues[15]) || 0;
    updateSalaryBasedOnLOP(payhead6, payhead11,payhead13,payhead14,payhead15, Number(value));
  } 
  else if (name === "incentive") {
    const newIncentive = Number(value);
    setIncentive(value);
     // Re-run the SD/TDS/etc. recalculation with the updated incentive
  updateSalaryBasedOnSDANDTDS(payheadValues, newIncentive);
  } 
  else {
    console.log("in handle input change");
    // setIncentive(value);
    const payheadMatch = name.match(/\d+/);
    const payheadId = payheadMatch ? parseInt(payheadMatch[0], 10) : -1;
    if (payheadId !== -1 || name == "incentive") {
          console.log("in handle input change 2");

      setPayheadValues((prev) => {
        const updated = { ...prev, [payheadId]: value };

        //  Trigger /re-calculation for TDS (11), PF, ESIC, Other Deduction
        const lowerName = payheads.find(ph => ph.id === payheadId)?.name.toLowerCase() || "incentive";
        const recalcTriggerFields = ["tds", "pf", "esic", "other deduction", "security deposit","incentive"];

        if (recalcTriggerFields.some((field) => lowerName.includes(field))) {
        const incentiveToUse = name === "incentive" ? Number(value) : Number(incentive);
          updateSalaryBasedOnSDANDTDS(updated, incentiveToUse);
        }

        return updated;
      });
    }
  }
};


  // Fetch Salary Details
  const fetchEmployeeSalaryDetails = async (empId?: string | number,
  suppressModal: boolean = false) => {
    if (!empId) return;

    try {
      console.log("Fetching salary before api call:",empId);
      setIsLoading(true);
      const params = new URLSearchParams(location.search);
      const month = params.get("month");
      const year = params.get("year");
      setSalaryBlocked(false);
      setAttendanceError(null);
      setAttendanceErrorDetails(null);
      const response = await api<AttendanceResponse>("/process-salary", {
  method: "POST",
  body: {
    id: empId,
    month: fiscalMonth || sessionStorage.getItem("month"),
    year: year || sessionStorage.getItem("year"),
  },
});

      if (response.status === "error") {
        const errRes = response as AttendanceErrorResponse;
        setAttendanceError(errRes.message);
        setAttendanceErrorDetails(errRes.errors || null);
        setSalaryBlocked(true);
        toast.error(errRes.message || "Failed to process salary.");
        if (!suppressModal) setShowModal(true);
        return;
      }

      if (response.status !== "success") {
        throw new Error("Failed to process salary");
      }

      // normalize keys to numbers
      const normalized: PayheadValues = {};
      Object.entries(response.payhead_values).forEach(([k, v]) => {
        normalized[Number(k)] = v;
      });

      setEmpName(response.emp);
      setDoj(response.doj);
      setLOP(String(response.lop));
      // if you have an â€œincentiveâ€ in the response, set it here too:
      setIncentive("0");

      setGross(response.gross);
      setNetSalary(response.netsalary);

      // THESE are the per-head values:
      setPayheadValues(normalized);

      // store internal ID for API calls, external code for display
      setEmployee_id(Number(empId) || empId);
      setEmployeeId(response.employeeid); // External employee code like E00119
      setEmployeeCode(response.employeeid);

       if (!suppressModal) {
      setShowModal(true);
    }
      // finally show the modal
      // setShowModal(true);
       console.log("Fetching salary after api call:",empId);
    } catch (err) {
      console.error("Error fetching salary details:", err);
    } finally {
      setIsLoading(false);
    }
  };

  //   useEffect(() => {
  // 	if (users.length > 0) {
  // 	  fetchEmployeeSalaryDetails(users[0].id);
  // 	}
  //   }, [users]);

  useEffect(() => {
    // after fetching users from the API
    console.log("Users fetched:", users);
  }, [users]);

  const updateSalaryBasedOnSDANDTDS = async (
    payheads: { [key: number]: string | number },
    incentiveValue: string | number
  ) => {
    try {
      setIsLoading(true); // Set loading state to true
      const response = await api<RecalculationResponse>(
        "/re-calculation",
        {
          method: "POST",
          body: {
            payheadValues: payheads,
            incentive: incentiveValue,
          },
        }
      );

      if (response) {
        setGross(response.gross);
        setNetSalary(Number(response.netsalary));
        setPayheadValues(response.payhead); // Update payhead values from the response
      }
    } catch (error: any) {
      console.error("Error updating salary:", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const updateSalaryBasedOnLOP = async (
    sd: number,
    tds: number,
    esic: number,
    otherDeduction: number,
    pf: number,
    lopValue: number
  ) => {
    try {
      const params = new URLSearchParams(location.search);
      const month = params.get("month");
      const year = params.get("year");
      setIsLoading(true);
      let numericId = editing
        ? editId
        : defaultEmployeeId;
      id: Number(numericId);
      if (typeof employeeId === "string" && isNaN(Number(employeeId))) {
        const found = users.find(u => String(u.employee_id) === String(employeeId) || String(u.id) === String(employeeId));
        numericId = found ? found.id : employeeId;
      }
      const basePayload = {
  lop: String(lopValue),
  month: String(month),
  year:  String(year),
  sd:    Number(sd),
  tds:   String(tds),
  esic:  String(esic),
  otherDeduction: String(otherDeduction),
  pf:    String(pf),
  incentive: String(incentive)
};

     const payload = editing
  ? { id: employee_id, ...basePayload }
  : { id: defaultEmployeeId, ...basePayload };

      const response = await api<{
        actual_salary: Record<string, string | number>;
        gross: string;
        netsalary: string;
        incentive: string;
      }>("/salary-calculation", {
        method: "POST",
        body: payload,
      });
      if (response) {
        const updatedPayheads: Record<number, string | number> = {};
        Object.entries(response.actual_salary).forEach(([key, value]) => {
          updatedPayheads[Number(key)] = value;
        });
        setPayheadValues(updatedPayheads);
        setGross(response.gross);
        setNetSalary(Number(response.netsalary));
        setIncentive(response.incentive);
      }
    } catch (error: any) {
      console.error("Error updating salary based on LOP:", error.message);
    } finally {
      setIsLoading(false);
    }
  };
  // const handleAddSalaryClick = useCallback(() => {
  //   if (!defaultEmployeeId) {
  //     console.warn("No default employee available to edit");
  //     toast.warning("Unable to determine default employee.");
  //     return;
  //   }
  //   fetchEmployeeSalaryDetails(defaultEmployeeId);
  // }, [defaultEmployeeId, fetchEmployeeSalaryDetails]);

  const sendMail = async (userId: number | null) => {
    if (!userId) return;

    setIsSending(true);
    try {
      const params = new URLSearchParams(location.search);
      const fiscalMonth = params.get("month");
      const year = params.get("year");
      await api<any>("/send-mail", {
        method: "POST",
        body: {
          EmployeeId: userId,
          month: fiscalMonth || sessionStorage.getItem("month"),
  year: year || sessionStorage.getItem("year"),
        },
      });
      // success toast/snackbar if needed
    } catch (error) {
      console.error("Failed to send mail:", error);
    } finally {
      setIsSending(false);
      setShowSendMailModal(false);
    }
  };

  const handlePrintClick = async (detail: any) => {
    try {
      const userId = detail.user.id;
     const fiscalMonth =
  queryParams.get("month") ||
  sessionStorage.getItem("month") ||
  String(new Date().getMonth() + 1); // fallback: current month number

const year =
  queryParams.get("year") ||
  sessionStorage.getItem("year") ||
  String(new Date().getFullYear()); // fallback: current year
      const response = await api<Blob>(
        `/create-pdf-file/${userId}/${year}/${fiscalMonth}`,
        {
          method: "GET",
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
          },
        }
      );

      // const contentDisposition = (response as any).headers?.["content-disposition"];
      // const filenameRegex = /filename=["']?([^"']+)["']?/;
      // const matches = contentDisposition ? contentDisposition.match(filenameRegex) : null;

      const filename = `${detail.user.employee_id}-${detail.user.name}-${fiscalMonth}-${year}-Slip.pdf`;

      const blob = new Blob([response], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    } catch (error) {
      console.error("Error while generating PDF:", error);
      setErrorMessage("The requested payslips are not available.");
      setTimeout(() => setErrorMessage(""), 3000);
    }
  };
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 554);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const PayrollMobileFilters = () => (
      <div className="px-2 px-md-2">
        <div className="profile-filters d-flex align-items-center flex-wrap">
          <div className="d-flex align-items-center gap-2  toggle-att-employeeSalaryMedia">
            <nav className="text-sm text-gray-600 toggle-att-employeeSalary">
              {breadcrumbs.map((crumb, idx) => (
                <span key={idx}>
                  {crumb.path ? (
                    <Link
                      to={crumb.path}
                      className="text-blue-600 hover:underline"
                    >
                      {crumb.title}
                    </Link>
                  ) : (
                    <span>{crumb.title}</span>
                  )}
                  {idx < breadcrumbs.length - 1 && (
                    <span className="mx-2">/</span>
                  )}
                </span>
              ))}
            </nav>
            <button
              className="btn btn-primary disbursement-btn"
              onClick={() => setShowModal2(true)}
            >
              Disbursement
            </button>
            {users.length >= 1 && (
              <button
                className="btn btn-outline-primary add_btn_size"
                onClick={async () => {
                  if (!defaultEmployeeId) {
                    toast.warning("Unable to determine default employee.");
                    return;
                  }
                  openedViaButtonRef.current = true;
                  setModalMode("add");
                  setEditing(false);

                  // Clear out any previous edit state

                  setEditId("");
                  setEmployee_id("");
                  setEmployeeId("");
                  setLop("");
                  setIncentive("");
                  setGross("");
                  setNetSalary("");
                  setPayheadValues({});

                  const firstEmpId = users[0].id;
                  setDefaultEmployeeId(firstEmpId);
                  setEditing(false);
                  setEmployeeId(firstEmpId);
                  // fetchEmployeeSalaryDetails(firstEmpId);
                  await fetchEmployeeSalaryDetails(firstEmpId);
                  // setShowModal(true);
                }}
                title="Add Salary"
              >
                <i className="ti ti-circle-plus" />
              </button>
            )}
          </div>
        </div>
      </div>
    );
    const PayrollDesktopFilters = () => (
      <div className="px-2 px-md-2">
        <div className="profile-filters d-flex align-items-center flex-wrap">
          <div className="d-flex align-items-center gap-2">
            <nav className="text-sm text-gray-600   toggle-att-employeeSalarymedia toggle-att-employeeSalarydesktop">
              {breadcrumbs.map((crumb, idx) => (
                <span key={idx}>
                  {crumb.path ? (
                    <Link
                      to={crumb.path}
                      className="text-blue-600 hover:underline"
                    >
                      {crumb.title}
                    </Link>
                  ) : (
                    <span>{crumb.title}</span>
                  )}
                  {idx < breadcrumbs.length - 1 && (
                    <span className="mx-2">/</span>
                  )}
                </span>
              ))}
            </nav>
            <button
              className="btn btn-primary disbursement-btn"
              onClick={() => setShowModal2(true)}
            >
              Disbursement
            </button>
            {users.length >= 1 && (
              <button
                className="btn btn-outline-primary add_btn_size"
                onClick={() => {
                  if (!defaultEmployeeId) {
                    toast.warning("Unable to determine default employee.");
                    return;
                  }
                  setModalMode("add");
                  setEditing(false);

                  // Clear out any previous edit state

                  setEditId("");
                  setEmployee_id("");
                  setEmployeeId("");
                  setLop("");
                  setIncentive("");
                  setGross("");
                  setNetSalary("");
                  setPayheadValues({});

                  fetchEmployeeSalaryDetails(defaultEmployeeId);
                }}
                title="Add Salary"
              >
                <i className="ti ti-circle-plus" />
              </button>
            )}
          </div>
        </div>
      </div>
    );

    setFilters(
      isMobileView ? <PayrollMobileFilters /> : <PayrollDesktopFilters />
    );
    return () => setFilters(null);

    // ONLY re-run *when* defaultEmployeeId changes
  }, [isMobileView, setFilters, defaultEmployeeId]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handleRowClick = (employeeId: number, employeeName: string) => {
    const payrollUrl = location.pathname + location.search; // /monthlySalary?month=4&year=2025
    const monthYear = sessionStorage.getItem("monthYear") || ""; // Apr-25
    sessionStorage.setItem("month", fiscalMonth);
    sessionStorage.setItem("year", year);

    navigate(`/profile/${employeeId}`, {
      state: {
        from: "payroll",
        payrollUrl,
        previousUrl: payrollUrl,
        monthYear,
        employeeName,
      },
    });
  };

  const loadNextEmployee = async (
    users: User[],
    currentEmployeeIndex: number,
    setCurrentEmployeeIndex: (val: number) => void,
    setFormState: (val: any) => void,
    fetchEmployeeSalaryDetails: (
      empId: number,
      month: string,
      year: string
    ) => Promise<void>
  ) => {
    const params = new URLSearchParams(location.search);
    const month = params.get("month") || "";
    const year = params.get("year") || "";

    if (users && users.length > 0) {
      const nextIndex = (currentEmployeeIndex + 1) % users.length;
      const nextUser = users[nextIndex];

      if (nextUser) {
        setFormState({
          employee_id: nextUser.id,
          emp_name: nextUser.name,
          LOP: 0,
          incentive: 0,
          gross: 0,
          netSalary: 0,
          payheadValues: {},
        });
        setCurrentEmployeeIndex(nextIndex);
        await fetchEmployeeSalaryDetails(nextUser.id, month, year);
      }
    }
  };

  // inside your MonthlySalary component, replace handleSubmit with this:

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const action = (e.nativeEvent as any).submitter.value as
      | "save_close"
      | "save_next";

    // build payload
    const basePayload = {
      month: fiscalMonth,
      year,
      LOP: Number(LOP),
      incentive: Number(incentive),
      gross: Number(gross),
      netSalary: Number(netSalary),
      payheadValues,
    };

    // if editing, include existing IDs
    const payload =
      modalMode === "edit"
        ? { editId: editId, employee_id: employee_id, ...basePayload }
        : { employee_id: Number(defaultEmployeeId), ...basePayload };
    try {
      // 1) save to the server
      await api("/save-actual-salary", {
        method: "POST",
        body: payload,
      });

      // 2) refresh the table
      await fetchSalaryData();

      if (action === "save_next") {
        // 3a) figure out who comes next in your users[] list
      const currentIndex = users.findIndex(
        (u) => u.id === Number(employee_id)
      );
      const nextIndex = (currentIndex + 1) % users.length;
      const nextUser = users[nextIndex];

      const nextEmpId = nextUser.id;
      const nextEmpCode = nextUser.employee_id;

      setDefaultEmployeeId(nextEmpId);
      setEmployeeId(nextEmpId);
      setEmployeeCode(nextEmpCode);



        // 3b) you may want to reset your incentiveAdded flag, etc.
        setIncentive("0");
        setIncentiveAdded(false);

        

        // 3c) load the modal for the next user
       await fetchEmployeeSalaryDetails(nextEmpId);
      //  setShowModal(true);


        // modal remains open, pre-filled with the new data
      } else {
        // save_close â†’ just close
        setShowModal(false);
      }
    } catch (err: any) {
        const message =
          err?.response?.data?.message ||
          "Unable to save salary. Please fix errors and try again.";
        setSalaryBlocked(true);
        toast.error(message, { autoClose: 4000 });
      }
  };

  const handleSelectAll = () => {
    const eligibleIds = salaryDetails
      .filter(
        (detail) =>
          detail.flag !== 1 && detail.user && typeof detail.user.id === "number"
      )
      .map((detail) => detail.user.id);

    const allSelected = eligibleIds.every((id) =>
      selectedEmployees.includes(id)
    );

    if (allSelected) {
      // Unselect all
      setSelectedEmployees((prev) =>
        prev.filter((id) => !eligibleIds.includes(id))
      );
    } else {
      // Add only eligible (non-disbursed)
      setSelectedEmployees((prev) => [...new Set([...prev, ...eligibleIds])]);
    }
  };

  const handleEmployeeSelect = (userId: number) => {
    setSelectedEmployees((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };
  // const handleSelectAll = (
  // 	salaryDetails: any[],
  // 	selectedEmployees: number[],
  // 	setSelectedEmployees: (val: number[]) => void
  //   ) => {
  // 	const allIds = salaryDetails.map((d) => d.user.id);
  // 	const newSelection =
  // 	  selectedEmployees.length === salaryDetails.length ? [] : allIds;
  // 	setSelectedEmployees(newSelection);
  //   };

  // const handleEmployeeSelect = (
  // 	id: number,
  // 	selectedEmployees: number[],
  // 	setSelectedEmployees: (val: number[]) => void
  //   ) => {
  // 	const updated = selectedEmployees.includes(id)
  // 	  ? selectedEmployees.filter((empId) => empId !== id)
  // 	  : [...selectedEmployees, id];
  // 	setSelectedEmployees(updated);
  //   };

  const handleClose = (
    setShowModal: (val: boolean) => void,
    resetFormState: () => void
  ) => {
    setShowModal(false);
    resetFormState();
    resetToFirstEmployee();
  };

  const selectAllRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (selectAllRef.current) {
      const eligible = salaryDetails.filter(
        (d) => d.flag !== 1 && d.user && typeof d.user.id === "number"
      );

      const allSelected = eligible.every((d) =>
        selectedEmployees.includes(d.user.id)
      );

      const someSelected = eligible.some((d) =>
        selectedEmployees.includes(d.user.id)
      );

      selectAllRef.current.indeterminate = someSelected && !allSelected;
    }
  }, [salaryDetails, selectedEmployees]);

  const employeeOptions: Option[] = useMemo(
    () =>
      users.map((u) => ({
        value: String(u.id),
        label: `${u.employee_id} — ${u.name}`,
      })),
    [users]
  );
  const selectableEmployees = salaryDetails.filter(
    (d) => d.flag !== 1 && d.user && typeof d.user.id === "number"
  );

  const columns = [
    {
      title: (
        <input
          ref={selectAllRef}
          type="checkbox"
          onChange={handleSelectAll}
          checked={
            selectableEmployees.every((d) =>
              selectedEmployees.includes(d.user.id)
            ) && selectableEmployees.length > 0
          }
        />
      ),
      key: "select",
      render: (_: any, record: SalaryDetail) =>
        record.flag !== 1 &&
        record.user &&
        typeof record.user.id === "number" ? (
          <input
            type="checkbox"
            checked={selectedEmployees.includes(record.user.id)}
            onChange={() => handleEmployeeSelect(record.user.id)}
          />
        ) : (
          <button className="btn btn-icon" title="blank" />
        ),
      width: 50,
      align: "center",
    },
    {
  title: "Employee Name",
  key: "name",
  width: "35%",
  render: (_: any, record: SalaryDetail) => {
    const maxNameLength = 15;
    const maxDesignationLength = 20;

    const truncateText = (text: string, maxLength: number) =>
      text && text.length > maxLength
        ? text.substring(0, maxLength) + "..."
        : text;

    return record.user ? (
      <div
        className="d-flex align-items-center"
        style={{ cursor: "pointer" }}
        onClick={() => handleRowClick(record.user.id, record.user.name)}
      >
        <img
          src={
            record.image_url ||
             "assets/img/users/default.jpg"
          }
          alt={record.user.name}
          style={{
            height: "35.5px",
            lineHeight: "36.5px",
            marginRight: "10px",
            borderRadius: "50%",
            cursor: "pointer",
          }}
        />
        <div className="ms-2">
          <h6 className="fw-medium" title={record.user.name}>
            {truncateText(record.user.name, maxNameLength)}
          </h6>
          <span className="fs-12 fw-normal" title={record.user.designation?.title || "-"}>
            {truncateText(record.user.designation?.title || "-", maxDesignationLength)}
          </span>
        </div>
      </div>
    ) : (
      <div className="text-muted">Unknown User</div>
    );
  },
}
,
    {
      title: "Gross[₹]",
      dataIndex: "Gross",
      key: "gross",
      align: "right",
      render: (v: number) => v.toLocaleString("en-IN"),
    },
    {
      title: "Inct[₹]",
      dataIndex: "Incentives",
      key: "incentives",
      align: "right",
      render: (v: number) => v.toLocaleString("en-IN"),
    },
    {
      title: "SD[₹]",
      dataIndex: "SD",
      key: "sd",
      align: "right",
      render: (v: number) => v.toLocaleString("en-IN"),
    },
    {
      title: "TDS[₹]",
      dataIndex: "TDS",
      key: "tds",
      align: "right",
      render: (v: number) => v.toLocaleString("en-IN"),
    },
    {
      title: "PT[₹]",
      dataIndex: "PT",
      key: "pt",
      align: "right",
      render: (v: number) => v.toLocaleString("en-IN"),
    },
    {
      title: "PF[₹]",
      dataIndex: "PF(C)",
      key: "pfC",
      align: "right",
      render: (v?: number) =>
      v != null ? v.toLocaleString("en-IN") : "–",
    },    
    {
      title: "ESIC[₹]",
      dataIndex: "ESIC",
      key: "esic",
      align: "right",
      render: (v?: number) =>
      v != null ? v.toLocaleString("en-IN") : "–",
    },
    {
      title: "Net[₹]",
      dataIndex: "Net_salary",
      key: "net",
      align: "right",
      render: (v: number) => v.toLocaleString("en-IN"),
    },
    {
      title: "Status",
      key: "flag",
      align: "center",
      render: (_: any, rec: SalaryDetail) =>
        rec.flag === 1 ? (
         <span className="badge bg-success text-white">
            Disbursed
          </span>
        ) : null,
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_: any, detail: SalaryDetail) => (
        <div className="d-flex">
          {detail.flag === 1 ? (
            <>
              <button
                className="btn btn-icon"
                title="Send Invoice"
                onClick={() => {
                  setShowSendMailModal(true);
                  setSelectedUserId(detail.user.id);
                }}
              >
                <i className="fa fa-envelope" />
              </button>
              <button
                className="btn btn-icon"
                title="Download"
                onClick={() => handlePrintClick(detail)}
              >
                <i className="fa fa-download" />
              </button>
              <button
                className="btn btn-icon"
                title="Info"
                onClick={() => handleInfoClick(detail)}
              >
                <i className="fa fa-info-circle" />
              </button>
            </>
          ) : (
            <button
              className="btn btn-icon"
              title="Edit"
              onClick={() => handleEditClick(detail)}
            >
              <i className="fa fa-edit" />
            </button>
          )}
        </div>
      ),
    },
  ];
  const updateEmployeeContext = (id: number, code: string) => {
  setDefaultEmployeeId(id);
  setEmployeeId(id);
  setEmployeeCode(code);
  fetchEmployeeSalaryDetails(id, true);
};

  const stats = [
    { title: "Gross", value: totalGross },
    { title: "SD", value: totalSD },
    { title: "TDS", value: totalTDS },
    { title: "PF", value: totalPF },
    { title: "ESIC", value: totalESIC },
    { title: "Net", value: totalNet },
  ];

  const resetToFirstEmployee = () => {
    if (openedViaButtonRef.current) {
    // Prevent auto-modal if user triggered already
    openedViaButtonRef.current = false;
    return;
  }

    if (users.length > 0) {
    const emp = users[0];
updateEmployeeContext(emp.id, emp.employee_id);
    } else {
      setDefaultEmployeeId(null);
      setEmployeeId("");
    }
  };
  console.log("users:", users);
  console.log("defult employee id:", defaultEmployeeId);

  useEffect(() => {
    if (openedViaButtonRef.current) {
    // Prevent auto-modal if user triggered already
    openedViaButtonRef.current = false;
    return;
  }

    if (users.length > 0) {
     const emp = users[0];
updateEmployeeContext(emp.id, emp.employee_id);
    } else {
      setDefaultEmployeeId(null);
      setEmployeeId("");
    }
  }, [users]);

  return (
    <div className="page-wrapper d-flex flex-column">
     
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="content flex-grow-1">
        <StatCardGrid
          items={stats}
          formatValue={formatCurrency}
          currencySymbol
        />

        <div className="card card-margin-bottom  ">
          <div className="card-body p-0  "  style={{
              height: tableHeight,
              display: "flex",
              flexDirection: "column",
            }} id="monthlysalary-list">
            <Table
              style={{ flex: 1  }}
              columns={columns}
              dataSource={salaryDetails}
              totalItems={totalItems}
              Selection={false}
              pageSize={pageSize}
              currentPage={currentPage}
              loading={loading}
              onPageChange={handlePageChange}
              rowKey={(record) => record.id}
            />
          </div>
        </div>
        </div>
    

      {showModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 2.6)",
              zIndex: 1040,
            }}
          />

          {/* Modal */}
          <div
            className="modal fade show d-block"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="salaryModalLabel"
            aria-modal="true"
            style={{ zIndex: 1050 }}
          >
            <div
              className="modal-dialog modal-dialog-scrollable modal-lg  "
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="salaryModalLabel">
                    {modalMode === "edit"
                      ? "Edit Salary"
                      : modalMode === "info"
                      ? "Info Employee"
                      : "Add Salary"}
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => {
                      setShowModal(false);
                      resetToFirstEmployee();
                    }}
                  />
                </div>

                {/* Scrollable Body */}
                <div
                  className="modal-body"
                  style={{ maxHeight: "100vh" }}
                >
                  <form id="salaryForm" onSubmit={handleSubmit}>
                    {attendanceError && (
                      <div className="alert alert-danger py-2 mb-3">
                        {attendanceError}
                      </div>
                    )}
                    {/* Your full form structure here */}
                    {/* You can paste all your form content from the previous code block */}
                    {/* TIP: Use Bootstrap grid (`row` and `col`) for alignment and responsiveness */}
                    {/* Keep footer inside form to keep buttons sticky below */}
                    <div className="row">
                      <div className="col-md-3 mb-3">
                        <label htmlFor="employee_id" className="form-label">
                          Employee Id
                        </label>
                        {modalMode === "edit" || modalMode === "info" ? (
                          <input
                            type="text"
                            className="form-control"
                            id="employee_id"
                            value={employeeId}
                            disabled
                          />
                        ) : (
                          <CommonSelect
                            options={employeeOptions}
                            value={
                              employeeOptions.find(
                                (opt) => String(opt.value) === String(defaultEmployeeId)
                              ) || null
                            }
                            onChange={(selectedEmployee) => {
                             if (selectedEmployee) {
                            const empId = Number(selectedEmployee.value);
                            const selected = users.find((u) => u.id === empId);
                            if (selected) {
                              setDefaultEmployeeId(selected.id);
                              setEmployeeId(selected.id); // internal DB ID
                              setEmployeeCode(selected.employee_id); // external code like E00174
                              fetchEmployeeSalaryDetails(selected.id); // correct fetch
                            }
                          }
                        }}
                            placeholder="Select Employee"
                            isFullWidth
                            forceFullWidth={true}
                          />
                        )}
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="lop" className="form-label">
                          LOP
                        </label>
                        {modalMode === "add" ? (
                          <input
                            type="number"
                            className="form-control"
                            name="LOP"
                            id="lop"
                            value={LOP}
                            step="0.5"
                            min="0"
                            onChange={handleInputChange}
                            disabled
                          />
                        ) : (
                          <div className="input-group">
                            <input
                              type="number"
                              className="form-control"
                              name="LOP"
                              id="lop"
                              value={LOP}
                              step="0.5"
                              min="0"
                              onChange={handleInputChange}
                              disabled={modalMode === "info" || modalMode === "edit"}
                            />
                            {modalMode === "edit" && (
                              <div className="input-group-append">
                                <button
                                  type="button"
                                  className="btn btn-outline-primary"
                                  onClick={() =>
                                    fetchEmployeeSalaryDetails(
                                      String(employee_id)
                                    )
                                  }
                                  // disabled
                                >
                                  <i className="fas fa-sync-alt"></i>
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="empname" className="form-label">
                          Name Of Employee
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="emp_name"
                          id="empname"
                          value={empName}
                          disabled
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="DOJ" className="form-label">
                          Date of Joining
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="doj"
                          id="DOJ"
                          value={doj}
                          disabled
                        />
                      </div>
                      
                          <h5 className="text-center">Per month</h5>
                          <div className="row" id="other-fields">
                            {payheads
                              .filter(payhead => payhead.description?.toLowerCase() !== "employer")
                                .map((payhead) => {
                                      console.log("Payhead object:", payhead); //  Add this line
                              const isEditable =
                                payhead.name.toLowerCase() === "security deposit" ||
                                payhead.name.toLowerCase() === "tds" ||
                                payhead.name.toLowerCase() === "esic" ||
                                payhead.name.toLowerCase() === "other deduction" ||
                                payhead.name.toLowerCase().includes("pf");

                              const label = payhead.name; //  Capital labels
                              const payheadId = payhead.id;
                            //   const value = payheadValues[payheadId] || "0";
                            const rawValue = payheadValues[payheadId];
                            const isValueEmpty = rawValue === undefined || rawValue === null || rawValue === "";
                            const value = isEditable
                              ? rawValue ?? "" // show empty if editable
                              : isValueEmpty
                              ? "0"
                              : rawValue; // show 0 only if non-editable and empty

                              return (
                                <div className="col-md-3 mb-3 "  key={payheadId}>
                                  <label htmlFor={`payhead-${payheadId}`} className="form-label text-truncate" title={label}>
                                    {label}
                                  </label>
                                  <input
                                    type="number"
                                    className={`form-control ${isEditable ? "editable-field" : "read-only-input"}`}
                                    name={`payhead[${payheadId}]`}
                                    id={`payhead-${payheadId}`}
                                    value={value}
                                    min="0"
                                    onChange={handleInputChange}
                                    disabled={!isEditable || (modalMode === "edit" && flag === 1)}
                                  
                                  />
                                </div>
                              );
                            })}

                            <div className="col-md-3 mb-3">
                              <label htmlFor="incentive" className="form-label">
                                Incentive/Bonus
                              </label>
                              <input
                                type="number"
                                className="form-control editable-field"
                                name="incentive"
                                id="incentive"
                                value={incentive}
                                onChange={handleInputChange}
                                disabled={modalMode === "edit" && flag === 1}
                              />
                            </div>

                            <div className="col-md-3 mb-3">
                              <label htmlFor="gross" className="form-label">
                                Gross
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="gross"
                                id="gross"
                                value={gross || "0"}
                                disabled
                              />
                            </div>

                            <div className="col-md-3 mb-3">
                              <label htmlFor="netSalary" className="form-label">
                                Net Salary
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="netSalary"
                                id="netSalary"
                                value={netSalary || "0"}
                                disabled
                              />
                            </div>
                          </div>

                          {/* <div className="row mt-3">
                          <div className="col-12">
                            {modalMode === "edit" && flag === 1 ? (
                              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Back</button>
                            ) : modalMode === "edit" ? (
                              <>
                                <button className="btn btn-primary" type="submit" name="action" value="save_close">Save & Close</button>&nbsp;
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Back</button>
                              </>
                            ) : users.length > 1 ? (
                              <>
                                <button className="btn btn-primary" type="submit" name="action" value="save_next">Save & Next</button>&nbsp;
                                <button className="btn btn-primary" type="submit" name="action" value="save_close">Save & Close</button>&nbsp;
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Back</button>
                              </>
                            ) : (
                              <>
                                <button className="btn btn-primary" type="submit" name="action" value="save_close">Save & Close</button>&nbsp;
                                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Back</button>
                              </>
                            )}
                          </div>
                        </div> */}
                          <div className="row mt-3">
                            <div className="col-12">
                              {modalMode === "info" ? (
                                <button
                                  className="btn btn-light"
                                  onClick={() => {
                                    setShowModal(false);
                                    resetToFirstEmployee();
                                  }}
                                >
                                  Back
                                </button>
                              ) : modalMode === "edit" && flag === 1 ? (
                                <button
                                  className="btn btn-light"
                                  onClick={() => {
                                    setShowModal(false);
                                    resetToFirstEmployee();
                                  }}
                                >
                                  Back
                                </button>
                              ) : modalMode === "edit" ? (
                                <>
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    value="save_close"
                                    name="action"
                                    disabled={isSaveDisabled}
                                  >
                                    Save & Close
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-light"
                                    onClick={() => {
                                      setShowModal(false);
                                      resetToFirstEmployee();
                                    }}
                                  >
                                    Back
                                  </button>
                                </>
                              ) : users.length > 1 ? (
                                <>
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    value="save_next"
                                    name="action"
                                    disabled={isSaveDisabled}
                                  >
                                    Save & Next
                                  </button>
                                  &nbsp;
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    value="save_close"
                                    name="action"
                                    disabled={isSaveDisabled}
                                  >
                                    Save & Close
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-light"
                                    onClick={() => {
                                      setShowModal(false);
                                      resetToFirstEmployee();
                                    }}
                                  >
                                    Back
                                  </button>
                                </>
                              ) : (
                                <>
                                  <button
                                    type="submit"
                                    className="btn btn-primary"
                                    value="save_close"
                                    name="action"
                                    disabled={isSaveDisabled}
                                  >
                                    Save & Close
                                  </button>
                                  &nbsp;
                                  <button
                                    className="btn btn-light"
                                    onClick={() => {
                                      setShowModal(false);
                                      resetToFirstEmployee();
                                    }}
                                  >
                                    Back
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                       

                    </div>

                    
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {showSendMailModal && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 2.6)",
              zIndex: 1040,
            }}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            tabIndex={-1}
            role="dialog"
            aria-modal="true"
            aria-labelledby="sendMailModalLabel"
            aria-hidden={!showSendMailModal}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="sendMailModalLabel">
                    Send Mail
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowSendMailModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <p>Are you sure you want to send this mail?</p>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    onClick={() => setShowSendMailModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => sendMail(selectedUserId)}
                    disabled={isSending}
                  >
                    {isSending ? "Sending..." : "Send"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* salary disbursement modal */}
      {showModal2 && (
        <>
          {/* Backdrop */}
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 2.6)",
              zIndex: 1040,
            }}
          />
          <div
            className="modal fade show d-block"
            style={{ zIndex: 1050 }}
            tabIndex={-1}
            role="dialog"
            aria-modal="true"
            aria-labelledby="salaryDisbursementLabel"
            aria-hidden={!showModal2}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="salaryDisbursementLabel">
                    Disburse Salary
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal2(false)}
                  />
                </div>
                <div className="modal-body">
                  <div className="form-group input-icon-end position-relative">
                    <label>
                      Select Date <span className="text-danger">*</span>
                    </label>
                    <div
                      className="date-picker-container"
                      style={{ position: "relative" }}
                    >
                      <DatePicker
                        value={disburseDate}
                        onChange={(date) => setDisburseDate(date)}
                        format="DD-MMM-YYYY"
                        placeholder="DD-MMM-YYYY"
                        className="form-control"
                        style={{ width: "100%" }}
                      />
                      <span className="input-icon-addon">
                        <i className="ti ti-calendar text-gray-7" />
                      </span>
                    </div>
                    {validationMessage && (
                      <div style={{ color: "red", marginTop: "4px" }}>
                        {validationMessage}
                      </div>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      setShowModal(false);
                      resetToFirstEmployee();
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={salaryDisbursement}
                    disabled={isSending}
                  >
                    {isSending ? "Disbursing..." : "Disburse"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default MonthlySalary;
